import FormErrorMessage from 'components/FormErrorMessage';
import colors from 'containers/App/colors';
import get from 'lodash/get';
import { merge } from 'ramda';
import Select from 'react-select';

const MultiSelectField = ({
  block,
  components,
  input,
  id,
  msg,
  meta: { touched, error },
  options,
  name,
  disabled,
  wrapperClassName = '',
  delimiter = ';',
  styles = {},
  placeholder,
}) => {
  const onChange = (data, meta) => {
    if (get(meta, 'action') === 'clear') {
      input.onChange('');
    } else if (get(meta, 'action') === 'remove-value') {
      // multiselect clear individual value
      const values = input.value.split(delimiter);
      const removedValue = get(meta, 'removedValue.value');
      input.onChange(values.filter((v) => v !== removedValue).join(delimiter));
    } else {
      const selectValues = data.map((val) => val.value).join(delimiter);
      input.onChange(selectValues);
    }
  };

  const onBlur = () => {
    input.onBlur();
  };

  const splitValues =
    typeof input.value === 'string' ? input.value.split(delimiter) : [];

  return (
    <div className={`${block ? 'block' : 'inline-block'} ${wrapperClassName}`}>
      <div className=''>
        <Select
          {...input}
          classNamePrefix='react-select'
          components={components}
          delimiter={delimiter}
          isDisabled={disabled}
          id={id}
          isMulti
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          options={options}
          placeholder={placeholder}
          styles={
            touched && error
              ? merge(styles, {
                  control: (base) => ({ ...base, borderColor: colors.danger }),
                })
              : styles
          }
          value={options.filter((option) => splitValues.includes(option.value))}
        />
      </div>
      {touched && error && (
        <FormErrorMessage>
          {get(msg, ['validation', error], 'Error')}
        </FormErrorMessage>
      )}
    </div>
  );
};

export default MultiSelectField;
